import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import taskIcon from '../assets/icon/task-list.svg';
import testIcon from '../assets/icon/test.png';
import './BottomBar.css';

const BottomBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bottom-bar">
      <button
        className={location.pathname === '/home' ? 'active' : ''}
        onClick={() => navigate('/home')}
      >
        <img src={taskIcon} alt="المهام" />
        <span>المهام</span>      </button>
      <button
        className={location.pathname === '/review-test' ? 'active' : ''}
        onClick={() => navigate('/review-test')}
      >
        <img src={testIcon} alt="اختبار" />
        <span>اختبار</span>      </button>
    </div>
  );
};

export default BottomBar;